// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.tastycrypto",
    name: "tastycrypto",
    homepage: "https://www.tastycrypto.com/",
    image_id: "357878c9-a195-4102-8f69-55eb2c578700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/tastycrypto-crypto-wallet/id1670102186",
        android: "https://play.google.com/store/apps/details?id=com.tastycrypto&hl=en",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "tastycrypto://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map